export default {
  getMarketManBuyer: (state) => state.marketManBuyer,
};
